/* eslint-disable */
import React, { useEffect, useState } from 'react';

// material-ui
import {
    Grid,
    Stack,
    Typography,
    TextField,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormControlLabel,
    Switch
} from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';
import { set, useDispatch } from 'store';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import AnimateButton from 'ui-component/extended/AnimateButton';
import SubCard from 'ui-component/cards/SubCard';
import MainCard from 'ui-component/cards/MainCard';
import { openSnackbar } from 'store/slices/snackbar';
import axiosServices from 'utils/axios';
import { findKeyInObject } from 'utils/findKeyInObjects';
import { LoadingButton } from '@mui/lab';
import { EmployeeActions } from 'store/slices/employees';
import moment from 'moment';
import { Error } from '@mui/icons-material';

// Enum values as array
const INVOICE_CALCULATION_TYPE = [
    { label: 'MLS Apartments', value: 'MLS_APARTMENTS' },
    { label: 'ABOR Days on Market', value: 'ABOR_DAYS_ON_MARKET' },
    { label: 'ABOR Cumulative Days on Market', value: 'ABOR_CUMULATIVE_DAYS_ON_MARKET' }
];

export default function InvoiceSettings() {
    const dispatch = useDispatch();
    const [invoice, setInvoice] = useState({});
    const [manulInvoiceLoading, setManulInvoiceLoading] = useState(false);
    const { editInvoiceSettings } = EmployeeActions;
    const [dates, setDates] = useState(null);
    // Simulate fetching data from API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axiosServices.get(`/settings/payment`, {
                    headers: {
                        authorization: `Bearer ${localStorage.getItem('serviceToken')}`
                    }
                });
                setInvoice(data);
            } catch (error) {
                // // console.log(error);
                toast.error('Something went wrong');
            }
        };
        fetchData();
    }, []);

    const validationSchema = Yup.object().shape({
        globalRate: Yup.string().required('Listing Per Month Rate is required!'),
        globalTax: Yup.string().nullable(),
        globalDiscount: Yup.string().nullable(),
        globalRateType: Yup.string().nullable(),
        globalDiscountType: Yup.string().nullable(),
        globalCalculationType: Yup.string().nullable(),
        excludeWithZero: Yup.boolean().nullable()
    });

    return (
        <MainCard title="" content={true}>
            <Grid container spacing={gridSpacing} sx={{ minHeight: '300px', minWidth: '75vw' }}>
                <Formik
                    enableReinitialize
                    initialValues={{
                        globalRate: invoice?.globalRate || 0,
                        globalRateType: invoice?.globalRateType || 'PER_MONTH',
                        globalTax: invoice?.globalTax || 0,
                        globalDiscountType: invoice?.globalDiscountType || 'PERCENTAGE',
                        globalDiscount: invoice?.globalDiscount || 0,
                        globalCalculationType: invoice?.globalCalculationType || 'MLS_APARTMENTS',
                        excludeWithZero: invoice?.excludeWithZero || false
                    }}
                    validationSchema={validationSchema}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                        try {
                            let res;

                            res = await dispatch(editInvoiceSettings({ values }));

                            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                                dispatch(
                                    openSnackbar({
                                        open: true,
                                        message: `Details saved successfully`,
                                        variant: 'alert',
                                        alert: {
                                            color: 'success'
                                        },
                                        close: true
                                    })
                                );
                                setStatus({ success: true });
                                setSubmitting(false);
                            } else {
                                dispatch(
                                    openSnackbar({
                                        open: true,
                                        message:
                                            findKeyInObject(res?.payload, `message`) ||
                                            findKeyInObject(res?.payload, `error`) ||
                                            `Internal server error.`,
                                        variant: 'alert',
                                        alert: {
                                            color: 'error'
                                        },
                                        close: true
                                    })
                                );
                            }
                        } catch (err) {
                            setStatus({ success: false });
                            setErrors({ submit: 'Invalid credentials' });
                            setSubmitting(false);
                        }
                    }}
                >
                    {({ errors, handleSubmit, handleChange, handleBlur, isSubmitting, values, touched, setFieldValue }) => (
                        <Grid item xs={12}>
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <SubCard title="Invoice Details" darkTitle>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    required
                                                    type="number"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Listing Rate Per Month"
                                                    name="globalRate"
                                                    value={values.globalRate}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.globalRate && errors.globalRate && (
                                                    <FormHelperText error>{errors.globalRate}</FormHelperText>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    type="number"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Per Listing Discount"
                                                    name="globalDiscount"
                                                    value={values.globalDiscount}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.globalDiscount && errors.globalDiscount && (
                                                    <FormHelperText error>{errors.globalDiscount}</FormHelperText>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    type="number"
                                                    InputLabelProps={{ shrink: true }}
                                                    label="Per Listing Tax"
                                                    name="globalTax"
                                                    value={values.globalTax}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.globalTax && errors.globalTax && (
                                                    <FormHelperText error>{errors.globalTax}</FormHelperText>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl
                                                    fullWidth
                                                    error={touched.globalCalculationType && Boolean(errors.globalCalculationType)}
                                                >
                                                    <InputLabel>Global Calculation Type</InputLabel>
                                                    <Select
                                                        label="Global Calculation Type"
                                                        name="globalCalculationType"
                                                        value={values.globalCalculationType || ''}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    >
                                                        {INVOICE_CALCULATION_TYPE.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {touched.globalCalculationType && errors.globalCalculationType && (
                                                        <FormHelperText error>{errors.globalCalculationType}</FormHelperText>
                                                    )}
                                                </FormControl>
                                                <Grid item xs={12} sm={12} sx={{ mt: 3 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={values.excludeWithZero === true}
                                                                onChange={(e) => setFieldValue('excludeWithZero', e.target.checked)}
                                                                name="globalCalculationTypeSwitch"
                                                            />
                                                        }
                                                        label="Don't show listing having 0 active days"
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container justifyContent="end" marginTop={4}>
                                                <Grid item>
                                                    <AnimateButton>
                                                        <LoadingButton
                                                            loading={isSubmitting}
                                                            variant="contained"
                                                            size="large"
                                                            onClick={() => {
                                                                handleSubmit();
                                                            }}
                                                        >
                                                            Save
                                                        </LoadingButton>
                                                    </AnimateButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                                <Grid item xs={12}>
                                    <SubCard title="Create Manual Invoice for selected month" darkTitle>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel required>Select Month & Year</InputLabel>
                                                    <Select
                                                        id="monthYear"
                                                        name="monthYear"
                                                        label="Select Month & Year"
                                                        onChange={(e) => {
                                                            const [selectedMonthIndex, selectedYear] = e.target.value.split('-');

                                                            const selectedDate = moment().set({
                                                                year: selectedYear,
                                                                month: selectedMonthIndex
                                                            });
                                                            const startDate = selectedDate.clone().startOf('month').toISOString();
                                                            const endDate = selectedDate.clone().endOf('month').toISOString();
                                                            // console.log(startDate, endDate);

                                                            setDates({ startDate, endDate });
                                                        }}
                                                    >
                                                        {Array.from({ length: 12 }).map((_, index) => {
                                                            const currentDate = new Date();
                                                            currentDate.setMonth(currentDate.getMonth() - index);
                                                            const month = currentDate.toLocaleString('default', { month: 'long' });
                                                            const year = currentDate.getFullYear();
                                                            const monthIndex = currentDate.getMonth();

                                                            if (year > 2024 || (year === 2024 && monthIndex >= 7)) {
                                                                return (
                                                                    <MenuItem key={`${monthIndex}-${year}`} value={`${monthIndex}-${year}`}>
                                                                        {`${month} ${year}`}
                                                                    </MenuItem>
                                                                );
                                                            }

                                                            return null;
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid container justifyContent="end" marginTop={4}>
                                                <Grid item>
                                                    <AnimateButton>
                                                        <LoadingButton
                                                            loading={manulInvoiceLoading}
                                                            variant="contained"
                                                            size="large"
                                                            onClick={async () => {
                                                                try {
                                                                    if (!dates) {
                                                                        toast.error('Please select a month and year to create invoice');
                                                                    }
                                                                    setManulInvoiceLoading(true);
                                                                    const { data } = await axiosServices.post(`/invoice/forMultipleUsers`, {
                                                                        ...dates
                                                                    });

                                                                    dispatch(
                                                                        openSnackbar({
                                                                            open: true,
                                                                            message: `Invoice created successfully`,
                                                                            variant: 'alert',
                                                                            alert: {
                                                                                color: 'success'
                                                                            },
                                                                            close: true
                                                                        })
                                                                    );
                                                                    setManulInvoiceLoading(false);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                    setManulInvoiceLoading(false);
                                                                }
                                                            }}
                                                        >
                                                            Create Invoice
                                                        </LoadingButton>
                                                    </AnimateButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Formik>
            </Grid>
        </MainCard>
    );
}
